export function toTitleCase(input: string): string {
  return input
    .replace(/[-_]+/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export function titleFromSlug(slug: string): string {
  return toTitleCase(slug);
}

export function parseCityState(param: string): { city: string; state: string } {
  const parts = param.split("-");
  if (parts.length < 2) return { city: toTitleCase(param), state: "" };
  const state = parts[parts.length - 1].toUpperCase();
  const city = toTitleCase(parts.slice(0, -1).join(" "));
  return { city, state };
}

export function formatPhoneNumber(phone: string): string {
  // Remove all non-numeric characters
  const cleaned = phone.replace(/\D/g, '');

  // Handle different phone number formats
  if (cleaned.length === 10) {
    // Format: XXX-XXX-XXXX
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  } else if (cleaned.length === 11 && cleaned.startsWith('1')) {
    // Format: +1-XXX-XXX-XXXX (PANDA)
    return `+1-${cleaned.slice(1, 4)}-${cleaned.slice(4, 7)}-${cleaned.slice(7)} (PANDA)`;
  } else if (cleaned.length === 13 && cleaned.startsWith('001')) {
    // Handle international format starting with 001
    return `+1-${cleaned.slice(3, 6)}-${cleaned.slice(6, 9)}-${cleaned.slice(9)} (PANDA)`;
  }

  // Return original if format doesn't match expected patterns
  return phone;
}


export const truncateString = (str: string, num: number) => {
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + '...';
};
